import React from "react"
import { useSearchParams } from "react-router-dom"
import { ConnectElement } from "@tap-payments/auth-jsconnect"
import { SettingAsyncData } from "./types"
import { getDeploymentRegion } from "./utils"

const products = {
  collect: {
    pk: "pk_test_EVpIAbRPJenzKXvHfdoy2FwL",
    mdn: "https://register.dev.tap.company",
    name: "GoCollect"
  },
  sell: {
    pk: "pk_test_JpfNaQV8vPnGOY6cyztdboRk",
    mdn: "https://register.dev.tap.company",
    name: "GoSell"
  },
  default: {
    pk: "pk_test_lat64TEDSvHrUOYAxVRe28PQ",
    mdn: window.location.origin,
    name: "Tap Connect Demo"
  }
}

type ConnectProps = {
  configToken?: string
  countryCode: string
  onMaturityChanged?: (maturity: "full" | "express") => Promise<void>
  onSettingFetched?: (data: SettingAsyncData) => void
}
export default function Connect({ countryCode, configToken, onMaturityChanged, onSettingFetched }: ConnectProps) {
  const [searchParams] = useSearchParams()
  const product = searchParams.get("product")
  const lang = searchParams.get("lang")
  const region = getDeploymentRegion()

  const getProduct = () => {
    if (product === "collect") return products.collect
    if (product === "sell") return products.sell
    return products.default
  }
  return (
    <ConnectElement
      open={true}
      configToken={configToken}
      merchantDomain={getProduct().mdn}
      publicKey={getProduct().pk}
      appInfo={{
        name: getProduct().name
      }}
      businessCountryCode={countryCode}
      language={(lang || "en") as any}
      onError={(error: any) => {
        console.log(JSON.stringify({ error }))
      }}
      onFlowCompleted={(res: any) => console.log("onFlowCompleted", res)}
      scope='merchant'
      onMaturityChanged={onMaturityChanged}
      onSettingFetched={onSettingFetched}
      region={region}
    />
  )
}
